<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M8.14,798.59V782.5H-7.14v16.09l7.6,3.91L8.14,798.59z M-6.4,798.14v-14.9H7.4v14.89l-6.94,3.52L-6.4,798.14L-6.4,798.14z
	 M0.5,789.01l-1.83,1.3l0.67-2.14l-1.8-1.34l2.25-0.02l0.71-2.13l0.71,2.13l2.25,0.02l-1.8,1.34l0.67,2.14L0.5,789.01z
	 M-3.98,792.82v-2.33l4.4,2.26l4.56-2.32v2.32l-4.57,2.32L-3.98,792.82z M4.98,794.28v2.32l-4.57,2.32l-4.4-2.26v-2.33l4.4,2.26
	L4.98,794.28z"/>
</svg>

</template>